import React from 'react';
import { Button } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.scss';

interface NoActiveBranchProps {
  isSuperAdmin: boolean;
}

// Shown instead of the module pages while every branch is deactive: those pages need a branch to work
export default function NoActiveBranchIndex({
  isSuperAdmin,
}: NoActiveBranchProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="settings__page">
      <div className="settings__card settings__card--narrow no-branch">
        <p className="no-branch__icon">
          <ShopOutlined />
        </p>
        <p className="settings__title">No active branch</p>
        <p className="settings__subtitle">
          {isSuperAdmin
            ? 'Every branch is deactive, so loans, customers and the other pages are unavailable. Activate a branch in Settings to continue.'
            : 'Your branch is deactive, so this page is unavailable. Please contact your administrator.'}
        </p>
        {isSuperAdmin && (
          <div className="settings__actions">
            <Button
              className="settings__button settings__button--primary"
              onClick={() => {
                navigate('/settings');
              }}
            >
              Go to Settings
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
